import { render, staticRenderFns } from "./storeDialog.vue?vue&type=template&id=c4473e68&scoped=true"
import script from "./storeDialog.vue?vue&type=script&lang=js"
export * from "./storeDialog.vue?vue&type=script&lang=js"
import style0 from "./storeDialog.vue?vue&type=style&index=0&id=c4473e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4473e68",
  null
  
)

export default component.exports